import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from 'react';
import { TagsOutlined } from "@ant-design/icons";
import axios from "axios";
import { Spin } from "antd";
import { axiosErrorHandler } from "../../../../../swzutils";
import ValOrDash from "../../../components/ValOrDash";
import HelpLabel from "../../../components/HelpLabel";
const ConsignmentCountWidget = (props, exportedRef) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateData, setStateData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    const refresh = () => {
        loadConsignmentCounts();
    };
    const loadConsignmentCounts = () => {
        setStateLoading(true);
        axios.get(`/admin/v1/dashboard/consignment-counts/${props.date}`)
            .then(response => {
            setStateData(response.data);
        }).catch(error => {
            setStateData(null);
            axiosErrorHandler(error);
        }).finally(() => {
            setStateLoading(false);
        });
    };
    const { totalConsignments, completedConsignments, completedByFleetVehicleConsignments, unassignedConsignments } = stateData ?? {};
    return (_jsx(Spin, { spinning: stateLoading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-coral", children: _jsx(TagsOutlined, {}) }), _jsxs("h2", { className: "widget-value", children: [_jsx(ValOrDash, { val: completedConsignments }), _jsxs("span", { className: "small", children: ["/", _jsx(ValOrDash, { val: totalConsignments }), " assigned"] }), !!completedByFleetVehicleConsignments && _jsxs("span", { className: "small", children: [" - (", _jsx(ValOrDash, { val: completedByFleetVehicleConsignments }), " company)"] })] }), _jsx("p", { children: _jsx(HelpLabel, { title: "Completed deliveries", helpText: _jsx("p", { children: "The number of completed deliveries out of the total deliveries that have been assigned to a vehicle." }) }) }), _jsx("div", { className: "widget-separator" }), _jsx("h2", { className: "widget-value", children: _jsx(ValOrDash, { val: unassignedConsignments }) }), _jsx("p", { children: _jsx(HelpLabel, { title: "Unassigned deliveries", helpText: _jsx("p", { children: "The count of unassigned deliveries that are scheduled for delivery today." }) }) })] }) }));
};
export default React.forwardRef(ConsignmentCountWidget);
